<template>
    <div class="low__title" v-if="fields" data-animate="slideUp">{{ fields['Mini title section'] }}</div>
    <div class="title" v-if="fields" data-animate="slideUp">{{ fields['Title section'] }}</div>
    <div class="desc" v-if="fields" v-html="fields['Text section']" data-animate="slideUp"></div>
    <ButtonOrange style="width: 189px;" @click="this.$scrollTo('footer');" v-if="fields" data-animate="slideUp">{{ fields['Text Button'] }}</ButtonOrange>
</template>

<script>
import ButtonOrange from '../UI/ButtonOrange.vue';
export default {
components: {
    ButtonOrange,
},
props: {
  fields: [Array,Object],
},
}
</script>

<style scoped>
.low__title{
/* Tabs/T1: 13px Medium */
color: rgb(85, 98, 114);
font-size: 13px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 16px;
}
.title{
/* Header/H1: 44px Medium */
color: rgb(5, 5, 5);
font-size: 44px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 24px;
}
.desc{
/* Paragraph/P1: 24px Regular */
color: rgb(85, 98, 114);
font-size: 24px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
padding-bottom: 32px;
}
@media (max-width: 1024px) {
.title{
font-size: 32px;
}
.desc{
font-size: 20px;
}
}
@media (max-width: 768px) {
.title{
font-size: 24px;
}
.desc{
font-size: 16px;
}
}
</style>